import { HttpResponse } from '@angular/common/http';
import { AfterContentInit, Component, OnInit } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/internal/operators/filter';
import { finalize } from 'rxjs/operators';
import { Client } from 'src/app/domain/client';
import { Contact } from 'src/app/domain/contact';
import { EUserRole } from 'src/app/domain/enum/user-role';
import { User } from 'src/app/domain/user';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { ClientSelectionBoxDialog } from 'src/app/tools/ui/client-selection-box/client-selection-box';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ContactSelectionBoxDialog } from 'src/app/tools/ui/contact-selection-box/contact-selection-box';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { UserBoxComponent } from 'src/app/tools/ui/user-box/user-box.component';

@Component({
    selector: 'app-user-configuration',
    templateUrl: './user-configuration.component.html',
    styleUrls: ['./user-configuration.component.scss']
})
export class UserConfigurationComponent implements OnInit, AfterContentInit {
    private subject: Subject<string> = new Subject();
    SearchedString: string = '';
    AllUsers: User[] = [];
    UserList: User[] = [];
    SelectedUser?: User = undefined;
    ClientList: Client[] = [];

    constructor(
        private loadingTask: LoadingTask,
        public coreData: CoreData,
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private userService: UserService
    ) { }

    ngOnInit(): void {

        this.GetAllUsers();
    }

    ngAfterContentInit(): void {

    }

    get CanSearch() {
        return StringTool.isNotNullOrEmpty(this.SearchedString);
    }

    getUserTypeLabel() {
        return StringConverter.getUserTypeName(this.SelectedUser?.Type as EUserRole);
    }

    onKeyUp() {
        this.searchClientList();
    }

    GetAllUsers() {
        this.userService.getAllUsers().subscribe(x => { this.AllUsers = x; this.UserList = x });
    }

    searchClientList() {

        this.UserList = this.AllUsers.filter(y =>
            y.Email.toLowerCase().includes(this.SearchedString.toLowerCase()) ||
            y.FirstName.toLowerCase().includes(this.SearchedString.toLowerCase()) ||
            y.LastName.toLowerCase().includes(this.SearchedString.toLowerCase()));

    }

    deleteClient(client: Client) {

        _.remove(this.SelectedUser?.ClientList!, x => x.Code === client.Code);
        this.userService.updateUser(this.SelectedUser as User).subscribe(x => {
            NotificationManager.handleSuccess(`Client retiré de ${this.SelectedUser?.Email}`, this.snackBar);
        });
    }

    assignSelectedUser(event: MatAutocompleteSelectedEvent) {
        this.SelectedUser = this.UserList.find(x => x.Email === event.option.value.Email) as User;
    }

    public compareWith(m1: User, m2: User) {
        return m1 && m2 ? m1.Email === m2.Email : m1 === m2;
    }

    displayFn(user: User | string) {
        if (!user) {
            return '';
        }
        if (user instanceof User) {
            return user ? user.Email : '';
        }
        if (typeof (user) === "string") {
            return user;
        }
        return '';
    }

    openCreationBox(user?: User) {
        const dialogRef = this.dialog.open(UserBoxComponent, {
            data: user,
            width: '555px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: User) => {
            if (!result) {
                return;
            }
            if (user) {
                this.userService.updateUser(result).subscribe(x => {
                    this.SelectedUser = result;
                    NotificationManager.handleSuccess('Utilisateur modifié !', this.snackBar);
                });
                return;
            }
            this.userService.createUser(result).subscribe(x => {
                NotificationManager.handleSuccess('Utilisateur ajouté !', this.snackBar);
                this.SelectedUser = result;
            });
        });
    }

    openClientSelectionBoxForNewClient() {
        const dialogRef = this.dialog.open(ClientSelectionBoxDialog, {
            width: '777px',
            // height: '400px',
            data: {
                alreadyAssignedList: this.SelectedUser?.ClientList
            }
        });

        dialogRef.afterClosed().subscribe((result: Client[]) => {
            if (result) {
                this.SelectedUser?.ClientList.push(...result);
                this.userService.updateUserWithStatusCode(this.SelectedUser as User)
                    .pipe(
                        filter((e: any) => e !== undefined),
                        finalize(() => this.loadingTask.deactivateLoading()))
                    .subscribe(
                        (event: HttpResponse<any>): void => {

                            if (event.status === 200) {
                                NotificationManager.handleSuccess(`Client ajouté à l\'utilisateur ${this.SelectedUser?.Email}`, this.snackBar);
                            } else if (event.status === 206) {
                                NotificationManager.handleWarning(event.body, this.snackBar);
                            } else if (event.status === 401) {
                                this.router.navigate(['/login']);
                            }
                        });
            }
        });
    }

    openContactSelectionBox() {
        const dialogRef = this.dialog.open(ContactSelectionBoxDialog, {
            width: '777px',
            data: {
                alreadyAssignedList: this.SelectedUser?.ClientList
            }
        });

        dialogRef.afterClosed().subscribe((result: string) => {
            if (result) {
                var c= new Contact () ;
                c.Code=result;
                this.SelectedUser?.ContactList.push(  c);
               
                this.userService.createContact(this.SelectedUser?.Id,c.Code).subscribe(x => {
                    NotificationManager.handleSuccess(`Contact ajouté à l\'utilisateur ${this.SelectedUser?.Email}`, this.snackBar);
                });
            }
        });
    }

    deleteContact(contact: Contact) {
        _.remove(this.SelectedUser?.ContactList!, x => x.Code === contact.Code);
        this.userService.deleteContact(this.SelectedUser?.Id,contact.Code).subscribe(x => {
            NotificationManager.handleSuccess(`Contact supprimé à l\'utilisateur ${this.SelectedUser?.Email}`, this.snackBar);
        });
    }

    deleteUser() {
        if (!this.SelectedUser)
            return;

        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: { message: 'Etes-vous sûr de vouloir supprimer cet utilisateur ?' }
        });
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {

                this.userService.deleteUser(this.SelectedUser!).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess(`L\'utilisateur ${this.SelectedUser?.FirstName} ${this.SelectedUser?.LastName} a été supprimé`, this.snackBar);
                        this.SelectedUser = undefined;
                    }
                })
            }
        });
    }

    resetPasswordForASpecificContact(email: string) {
        this.userService.askForResetPassword(email).subscribe(x => {
            NotificationManager.handleSuccess(`Un nouveau mail de changement de mot de passe a été envoyé à cette adresse: ${email}`, this.snackBar);
        })
    }

    activeUnactiveUser(email: string) {
        this.userService.activeUnactiveUser(email).subscribe(x => {
            this.SelectedUser!.IsActive = x;
            NotificationManager.handleSuccess(`Utilisateur ${x ? 'activé' : 'désactivé'}`, this.snackBar);
        })
    }
}
